import React from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: 'website' | 'article' | 'profile';
  jsonLd?: object | object[];
  noindex?: boolean;
}
export const SEO: React.FC<SEOProps> = ({
  title = 'Online gevonden worden in Noord-Holland Noord | Noord Digital',
  description = 'Noord Digital zorgt dat ondernemers in Noord-Holland Noord online gevonden worden en professioneel overkomen. Websites, vormgeving, hosting, e-mail en SEO uit Oudkarspel.',
  keywords = 'online gevonden worden, website laten maken Noord-Holland, huisstijl laten maken, vormgeving Dijk en Waard, seo Noord-Holland Noord, webdesign Oudkarspel',
  canonical = 'https://noorddigital.nl',
  ogImage = 'https://noorddigital.nl/og-image.jpg',
  ogType = 'website',
  jsonLd,
  noindex = false
}) => {
  const schemas = jsonLd ? Array.isArray(jsonLd) ? jsonLd : [jsonLd] : [];
  return <Helmet data-id="element-666" data-mp="29ih9l7sgvjvm">
      {/* Favicon */}
      <link rel="icon" type="image/svg+xml" href="https://cdn.magicpatterns.com/uploads/mue3TYJ7nvuB2eSYNuEqcF/Logo_favicon.svg" data-id="element-667" data-mp="29iqyes1rzkzq" />
      <link rel="apple-touch-icon" href="https://cdn.magicpatterns.com/uploads/mue3TYJ7nvuB2eSYNuEqcF/Logo_favicon.svg" data-id="element-668" data-mp="1zkb98umb6lsv" />

      {/* Primary Meta Tags */}
      <title data-id="element-669" data-mp="1ukykg4bvn4nn">{title}</title>
      <meta name="title" content={title} data-id="element-670" data-mp="1qjmutyt06jfg" />
      <meta name="description" content={description} data-id="element-671" data-mp="1qkerlcyc6n7b" />
      <meta name="keywords" content={keywords} data-id="element-672" data-mp="1lswr0q086omv" />
      <meta name="author" content="Noord Digital" data-id="element-673" data-mp="1ls4v1e2puow2" />
      <meta name="application-name" content="Noord Digital" data-id="element-674" data-mp="1gtk4659cthka" />
      <link rel="canonical" href={canonical} data-id="element-675" data-mp="1gu3byt5aipkl" />
      <link rel="alternate" hrefLang="nl-nl" href={canonical} data-id="element-676" data-mp="1bv8upvmz192l" />
      <link rel="alternate" hrefLang="x-default" href={canonical} data-id="element-677" data-mp="1bsmdf4aa3f76" />

      {/* Crawling */}
      <meta name="robots" content={noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large, max-snippet:-1'} data-id="element-678" data-mp="16uunugx3w565" />
      <meta name="geo.region" content="NL-NH" data-id="element-679" data-mp="s7m3aphwqnhi" />
      <meta name="geo.placename" content="Oudkarspel" data-id="element-680" data-mp="x8jkayr6lbhf" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-681" data-mp="j8ildouh8e4l" />
      <meta property="og:site_name" content="Noord Digital" data-id="element-682" data-mp="j9tp5onx9lvp" />
      <meta property="og:locale" content="nl_NL" data-id="element-683" data-mp="o6tws40f6wox" />
      <meta property="og:url" content={canonical} data-id="element-684" data-mp="o9g0fsk6ws1v" />
      <meta property="og:title" content={title} data-id="element-685" data-mp="1bwo4661yzt1s" />
      <meta property="og:description" content={description} data-id="element-686" data-mp="1bz0vh9tmbfri" />
      <meta property="og:image" content={ogImage} data-id="element-687" data-mp="1fxgfr5ybea18" />
      <meta property="og:image:alt" content={title} data-id="element-688" data-mp="1274lp1i6617g" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-689" data-mp="126ux9icrw23v" />
      <meta property="twitter:url" content={canonical} data-id="element-690" data-mp="17565xprc06ki" />
      <meta property="twitter:title" content={title} data-id="element-691" data-mp="1uvsedi58zsv1" />
      <meta property="twitter:description" content={description} data-id="element-692" data-mp="1uu7hvmzdhzuj" />
      <meta property="twitter:image" content={ogImage} data-id="element-693" data-mp="1zn0ipzrq0o1c" />

      {/* Structured data */}
      {schemas.map((schema, index) => <script key={index} type="application/ld+json" data-id="element-694" data-mp="28zrbmxbcb2wx" data-mpi={index}>
          {JSON.stringify(schema)}
        </script>)}

      {/* Language */}
      <html lang="nl" data-id="element-695" data-mp="2ir43hox51t2y" />
    </Helmet>;
};